import { NgModule } from '@angular/core';
import { SharedModule } from '../shared/shared.module';
import { AuthenticationComponent } from './containers/authentication/authentication.component';

@NgModule({
  declarations: [AuthenticationComponent],
  imports: [SharedModule],
  exports: [AuthenticationComponent],
})
export class AuthLayoutModule {}
